import AllianceStyle from './AllianceStyle.module.css';
import { useEffect, useState, useRef } from "react";
import {responseMsg} from "../../common/ResponseMsg";
import AllianceAddModal from "./AllianceAddModal";
import AllianceEditModal from './AllianceEditModal';
import ManagementPage from '../../../shared/components/ManagementPage';
import ManageButton from '../../../shared/components/ManageButton';
import Input from '../../../shared/components/Input';
import Text from '../../../shared/components/Text';
import useDevice from '../../../shared/hooks/useDevice';
import Flex from '../../../shared/components/Flex';
import CommonSelect from '../../../shared/components/CommonSelect';
import Padding from '../../../shared/components/Padding';
import Card from '../../../shared/components/Card';
import GridInfo from '../../../shared/components/GridInfo';
import Spacer from '../../../shared/components/Spacer';
import EmptyState from '../../common/EmptyState';
import GridLoading from '../../common/GridLoading';
import ScrollModal from '../../common/ScrollModal';
import getRowNo from '../../../shared/components/utils/getRowNo';
import AgGridTable from '../../common/AgGridTable';
import { useAlert } from '../../../shared/components/AlertProvider';
import { addTooltipField } from '../../../shared/utils/gridTitleUtil';

function Alliance({name}) {
    const [render, setRender] = useState(false);
    const [searchObj, setSearchObj] = useState({req: {allianceName: ""}});
    const [regions, setRegions] = useState();
    const [alliances, setAlliances] = useState();
    const [selectedAlliance, setSelectedAlliance] = useState();
    const [selectedRegionCode1, setSelectedRegionCode1] = useState({});
    const [allianceAddModal, setAllianceAddModal] = useState({});
    const [allianceUpdateModal, setAllianceUpdateModal] = useState({});
    const device = useDevice();
    const isMobile = device !== 'desktop';
    const [useYn, setUseYn] = useState("Y");
    const cardRef = useRef(null);
    const [bodyHeight, setBodyHeight] = useState(0);
    const showAlert = useAlert();
    const [loading, setLoading] = useState(false);
    
    const useYnOption = [
        {text: "사용", value: "Y"},
        {text: "미사용", value: "N"}
    ]

    const search = () => {
        const allianceName = document.getElementById('allianceName').value || "";
        setSearchObj({req: {
            allianceName
        }})
    }

    const apiGetAllianceList = (page) => {
        setLoading(true);
        let url = '/api/system/alliances?'
        const pagingSize = 20;

        if (page) {
            url += `page=${page-1}&`
            url += `size=${pagingSize}&`
        }

        if(searchObj) {
            Object.keys(searchObj.req).forEach(ele => {
                if (searchObj.req[ele]) {
                    url += `${ele}=${searchObj.req[ele]}&`
                }
            })
            url += `useYn=${useYn}&`;
            
            fetch(url ,{
                method:"GET"
            })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    setAlliances(getRowNo(json.data));
                    setSelectedAlliance(json.data[0]);

                }  else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            })
            .finally(() => {setLoading(false)});
        } 
    };

    useEffect(() => {
        if (!cardRef.current) return;

        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
            setBodyHeight(entry.contentRect.height);
            }
        });

        observer.observe(cardRef.current);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        apiGetAllianceList();
    }, [render, searchObj, useYn]);

    useEffect(() => {
        fetch("/api/system/codes/REGION/2",{
            method:"GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    setRegions(json.data)

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch(error => {
            });
    }, []);

    useEffect(() => {
        if (!selectedAlliance || !regions) return;

        const lv1List = [
            ...new Set(
                selectedAlliance.regions
                    ?.filter(r => r.depth === 3)
                    .map(r => r.parent)
            )
        ]
            .map(parentId => regions.find(r => r.id === parentId))
            .filter(Boolean);

        if (lv1List.length > 0) {
            setSelectedRegionCode1(lv1List[0]);
        }
    }, [selectedAlliance, regions]);


    const rendering = () => {
        setAllianceAddModal({ open: false });
        setAllianceUpdateModal({ open: false });
        setRender(prev => !prev);
    };

    const openAllianceAddModal = () => {
        setAllianceAddModal({
            open: true,
            close: () => setAllianceAddModal({ open: false }),
            main: <AllianceAddModal rendering={rendering} />
        });
    };

    const openAllianceUpdateModal = (cell) => {
        setAllianceUpdateModal({
            open: true,
            close: () => setAllianceUpdateModal({ open: false }),
            main: (
                <AllianceEditModal
                    alliance={cell.data}
                    rendering={rendering}
                />
            )
        });
    };

    const leftGridConfig = {
        columnDefs: addTooltipField(
            [
                { headerName: '번호', field: 'rowNo', width: 100},
                { headerName: '소속코드', field: 'allianceCode', width: 350, cellStyle: { textAlign: "left" } },
                { headerName: '소속명', field: 'allianceName', width: 350, cellStyle: { textAlign: "left" } },
                { headerName: '사용여부', field: 'useYn', width: 250, valueFormatter: (params) => params.value === 'Y' ? '사용' : '미사용' },
            ]
        ),
        rowData: alliances,
        rowSelection: 'single',
    };

    const renderLv1List = () => {
        if (loading) return <GridLoading />;
        if (!selectedAlliance || !regions) return <EmptyState />;

        const lv1List = [
            ...new Set(
                selectedAlliance.regions
                    ?.filter(r => r.depth === 3)
                    .map(r => r.parent)
            )
        ]
            .map(parentId => regions.find(r => r.id === parentId))
            .filter(Boolean);

        if (!lv1List.length) return <EmptyState />;

        return lv1List.map((item, idx) => {
            const count = selectedAlliance.regions.filter(
                r => r.depth === 3 && r.parent === item.id
            ).length;

            const isSelected = selectedRegionCode1?.id === item.id;

            const boxClass = isSelected
                ? AllianceStyle["selected-box"]
                : AllianceStyle["unselected-box"];

            const textClass = isSelected
                ? AllianceStyle["selected-text"]
                : AllianceStyle["unselected-text"];

            return (
                <div
                    key={item.id}
                    className={boxClass}
                    onClick={() => setSelectedRegionCode1(item)}
                    style={{cursor: "pointer"}}
                >
                    <Text className={textClass}>
                        {item.name}
                        <span className={textClass} style={{ marginLeft: 6 }}>
                            ({count})
                        </span>
                    </Text>
                </div>
            );
        });
    };


    const renderLv2List = () => {
        if (loading) return <GridLoading />;
        if (!selectedAlliance || !selectedRegionCode1) return <EmptyState />;

        const lv2List = selectedAlliance.regions.filter(
            r => r.depth === 3 && r.parent === selectedRegionCode1.id
        );

        if (!lv2List.length) return <EmptyState />;

        return lv2List.map(item => (
            <div
                key={item.id}
                className={AllianceStyle["selected-box"]}
                style={{ backgroundColor: "#FFF8F0"}}
            >
                <Text className={AllianceStyle["selected-text"]}>
                    {item.name}
                </Text>
            </div>
        ));
    };


    const renderCard = (title, renderFn) => (
        <div
            style={{
                flex: 1,
                backgroundColor: "#F7F8FA",
                border: "1px solid #DBDBDB",
                borderRadius: "16px",
                display: "flex",
                flexDirection: "column",
                minHeight: 0
            }}
        >
            <Padding paddingX={10} paddingY={15}>
                <Text weight={"bold"} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    {title}
                </Text>
            </Padding>

            <div style={{ flex: 1, minHeight: 0, padding: "0 10px 15px 10px", display: "flex", flexDirection: "column" }}>
                <Card ref={cardRef} fullWidth style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                    <div style={{ height: bodyHeight, overflow: 'auto'}}>
                        <Padding paddingBottom={0}>
                            {renderFn()}
                        </Padding>
                    </div>
                </Card>
            </div>
        </div>
    );

    return (
        <ManagementPage
            title='소속관리'
            actions={
                <>
                    <ManageButton
                        onClick={() => search()} 
                        btnType='search'
                    />
                    <ManageButton onClick={openAllianceAddModal} btnType='regist'/>
                </>
            }
            searchArea={
                <>
                    <Flex flexDirection={isMobile ? 'column' : 'row'} gap={isMobile ? 8 : 30}>
                        <Flex alignItems='center'>
                            <Text size={"sm"} style={{width: "70px", flexShrink: 0}}>소속명</Text>
                            <Input
                                id='allianceName' 
                                fullWidth={isMobile} 
                                name="allianceName" 
                                placeholder='소속명을 입력해 주세요' 
                                style={{flex: 1}} 
                                maxLength={200} 
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        search()
                                    }
                                }}
                                autoFocus
                            />
                        </Flex>
                        <div style={{ width: isMobile ? "auto" : "324px" }}>
                            <CommonSelect label='사용여부' fullWidth value={useYn} data={useYnOption} onChange={setUseYn}/>
                        </div>
                    </Flex>
                </>
            }
        >
            <Flex flexDirection={isMobile ? 'column' : 'row'} style={{flex: 1}} gap={15}>
                <Card fullWidth style={{ display: 'flex', flex: isMobile ? "none" : 3, height: isMobile ? "336px" : "auto" }}>
                    <Padding paddingX={10} paddingY={15} style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                        <GridInfo title='지역 권한 목록' width={490}
                            content='항목을 클릭하면 선택한 소속에 포함된 지역이 오른쪽 지역 권한에 표시됩니다.
                                        항목을 더블클릭하면 선택한 소속을 수정하는 화면이 열립니다.' />
                        <Spacer direction='vertical' size={15} />
                        <AgGridTable
                            rowData={alliances}
                            columnDefs={leftGridConfig.columnDefs}
                            onRowClicked={(cell) => {
                                setSelectedAlliance(cell.data)
                            }}
                            onRowDoubleClicked={(cell) => {
                                openAllianceUpdateModal(cell)
                            }}
                            selectedRow={selectedAlliance}
                            tooltipShowDelay={0}
                            tooltipHideDelay={2000}
                            loading={loading}
                        />
                    </Padding>
                </Card>
                {renderCard("지역 권한 LV1", renderLv1List)}
                {renderCard("지역 권한 LV2", renderLv2List)}
            </Flex>

            <ScrollModal
                headerText="소속 등록"
                size={"524px"}
                modal={allianceAddModal}
            >
            </ScrollModal>

            <ScrollModal
                headerText="소속 수정"
                size={"524px"}
                modal={allianceUpdateModal}
            >
            </ScrollModal>
        </ManagementPage>
    );
}

export default Alliance;